import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { APP_PATHS } from '../constants/app-routes';
import { ClientOwnerService } from '../services/client-owner.service';

export const reservationsEnabledGuard: CanActivateFn = () => {
  const owner = inject(ClientOwnerService);
  const router = inject(Router);
  const allow = (enabled: boolean) => (enabled ? true : router.createUrlTree([APP_PATHS.myCompany]));
  if (owner.hasProfile()) {
    return allow(owner.reservationsEnabled());
  }
  return owner.mine().pipe(
    map((profile) => allow(!!profile.reservationsEnabled)),
    catchError(() => of(router.createUrlTree([APP_PATHS.myCompany])))
  );
};
